/*
  地址 id 的读写统一委托给 utils/addressStorage.js,
  payment2 / payment3 等旧模块继续调这两个函数即可, 不会和新缓存出现两套 key.
*/
import {
  readAddressCache,
  writeAddressCache
} from './addressStorage'

export const adType = {
  payment: 'payment'
}

export function setAddressId(adid) {
  writeAddressCache({ addressId: adid })
}

export function getAddressId() {
  const cache = readAddressCache()
  return cache ? cache.addressId : ''
}

export function setPayInfo(datas) {
  sessionStorage.setItem('payInfo', JSON.stringify(datas))
}

export function getPayInfo() {
  return JSON.parse(sessionStorage.getItem('payInfo'))
}
